import React from 'react';
import styled from "styled-components";
import PropTypes from "prop-types";
import UnifiedSearch from "components/UnifiedSearch";
import Image from "next/image";

const OuterWrapper = styled.section`
  background-color: ${({ theme }) => theme.themeColors.lightGreen1};
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 4rem 1.125rem 1.5rem;
  width: 100%;

  ${({ theme }) => theme.mq.md`
    padding: 5rem 1.75rem 2rem;
  `}

  ${({ theme }) => theme.mq.lg`
    align-items: center;
    flex-direction: row;
    padding: 3rem 1.5rem 5rem 1.5rem;
  `}

  ${({ theme }) => theme.mq.xxl`
    padding: 2.375rem 1.5rem 4.5rem 6.25rem;
  `}
`;

export const FormWrapper = styled.div`
  background-color: ${({ theme }) => theme.themeColors.white};
  border: 0.0625rem solid ${({ theme }) => theme.themeColors.darkGreen4};
  border-radius: 1.125rem;
  padding: 1.675rem 1.5rem;
  order: 2;
  width: 100%;

  ${({ theme }) => theme.mq.md`
    padding: 2rem 2rem 1.75rem;
  `}

  ${({ theme }) => theme.mq.lg`
    border-radius: 1.875rem;
    margin: 0 .5rem 0 0;
    max-width: 26.25rem;
    order: 1;
    padding: 2rem 2rem 1.675rem;
  `}

  ${({ theme }) => theme.mq.xl`
    margin: 0 2rem 0 0;
    max-width: 30rem;
    padding: 3rem 2rem 1.675rem;
  `}

  ${({ theme }) => theme.mq.xxl`
    margin: 0 3.25rem 0 0;
  `}
`;

export const ImageWrapper = styled.div`
  align-self: center;
  height: 13.25rem;
  margin: 0 auto 3rem;
  order: 1;
  padding: 0;
  position: relative;
  width: 100%;

  ${({ theme }) => theme.mq.md`
    height: 30rem;
    max-width: 42.5rem;
    margin: 0 auto 5.75rem;
  `}

  ${({ theme }) => theme.mq.lg`
    height: 28.75rem;
    margin: 2.4375rem 0 1.125rem 1.375rem;
    max-width: 48.25rem;
    order: 2;
  `}
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.themeColors.darkGreen1};
  letter-spacing: 0.033rem;
  margin-bottom: 1.25rem;
  margin-top: 0;
  text-align: left;

  div {
    font-family: ${({ theme }) => theme.fontStacks.serifItalic};
    font-style: italic;
  }

  br {
    display: none;
  }

  ${({ theme }) => theme.mq.md`
    font-size: 2.8125rem;
    margin-bottom: 2.5rem;

    br {
      display: block;
    }

    div {
      display: inline;
    }
  `}

  ${({ theme }) => theme.mq.lg`
      font-size: 2.5rem;

      div {
        display: block;
      }

      br {
        display: none;
      }
  `}

  ${({ theme }) => theme.mq.xl`
      font-size: 3rem;
      margin-bottom: 4.5rem;
  `}
`;

export default function MainSearch({ backgroundImage, title }) {
  return (
    <OuterWrapper backgroundImage={backgroundImage}>
      <FormWrapper>
        <Title>{title}</Title>
        <UnifiedSearch/>
      </FormWrapper>
      <ImageWrapper>
        <Image
          alt="Illustration of pets and parents playing in a park in front of a GoodFriend groomer"
          layout="fill"
          src="/hero_illustration.png"
          objectFit="contain"
          priority
        />
      </ImageWrapper>
    </OuterWrapper>
  );
};

MainSearch.propTypes = {
  backgroundImage: PropTypes.string,
  title: PropTypes.shape({}),
};

MainSearch.defaultProps = {
  backgroundImage: "",
  title: undefined,
};